import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@/assets/styles/index.css'
import YmElementCommon from "ym-element-common"
import {authCheckSave} from "@/utils/make";

const app = createApp(App).use(router).use(store)
for (const [key,component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key,component)
}
app.use(YmElementCommon.install)
app.use(ElementPlus,{ locale:zhCn})
authCheckSave().then(()=>{
    app.mount('#app')
})
